import React from "react";

const ManditoryStar = ({ title }) => {
  return (
    <div className="flex items-center">
      <label className="label">{title}</label>
      <span className="ml-1 font-semibold textlg text-speed-red">*</span>
    </div>
  );
};

export default ManditoryStar;
